<template>
  <div class="outsource-list">
    <Loader
      v-if="loaderEnabled"
      :logo="loaderLogo"
    />
    <KTCodePreview :title="title">
      <template v-slot:preview>
        <OutsourceSearchBar
          :params="apiParams"
          :page-size="selectedPageSize"
          :provider-options="providerOptions"
          :option-stores="optionStores"
          :list-company="listCompany"
          :option-page-size="optionPageSize"
          :is-loading="isLoading"
          @filter="onFilter"
          @reset="onReset"
          @page-size-change="onPageSizeChange"
        />
        <OutsourceListTable
          :items="listItem"
          :is-loading="isLoading"
          :total-items="totalItems"
          :number-of-page="numberOfPage"
          :current-page="currentPage"
          :limit="limit"
          @view="viewDetail"
          @receive="openReceiveModal"
          @page-change="onPageChange"
        />
        <ReceiveOutsourceModal
          ref="receiveModalRef"
          :item="selectedForReceive"
          @done="onReceiveDone"
        />
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { mapGetters } from 'vuex';
import Loader from '@/view/content/Loader.vue';
import timeUtils from '@/utils/date';
import apiCommonMixin from '@/view/mixins/api-common.mixins';
import { getOutsourceList } from './warrantyOutsourceApi';
import OutsourceSearchBar from './components/OutsourceSearchBar.vue';
import OutsourceListTable from './components/OutsourceListTable.vue';
import ReceiveOutsourceModal from './components/ReceiveOutsourceModal.vue';

export default {
  name: 'ListOutsource',
  mixins: [apiCommonMixin],
  components: {
    KTCodePreview,
    Loader,
    OutsourceSearchBar,
    OutsourceListTable,
    ReceiveOutsourceModal,
  },
  data() {
    return {
      apiParams: {
        startDate: null,
        endDate: null,
        status: null,
        providerId: null,
        storeId: null,
        keyword: null,
        billId: null,
        companyId: null,
      },
      listCompany: [],
      listItem: [],
      totalItems: 0,
      numberOfPage: 1,
      selectedPageSize: null,
      limit: 10,
      optionPageSize: [10, 25, 50, 100],
      providerOptions: [],
      optionStores: [],
      isLoading: false,
      selectedForReceive: null,
    };
  },
  computed: {
    ...mapGetters(['layoutConfig']),
    loaderEnabled() {
      return !/false/.test(this.layoutConfig('loader.type'));
    },
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig('loader.logo');
    },
    currentPage() {
      return Number(this.$route.query.page) || 1;
    },
    title() {
      return 'Danh sách phiếu outsource';
    },
  },
  created() {
    this.fetchCompanyOptions();
    this.fetchData();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.title }]);
    this.loadProviders();
  },
  methods: {
    async fetchCompanyOptions() {
      const list = await this.fetchCompanies();
      this.listCompany = [{ id: null, name: 'Tất cả doanh nghiệp' }, ...list];
    },
    loadProviders() {
      // No-op: SupplierAutosuggest tự handle search-on-demand
    },
    onFilter(params) {
      this.apiParams = { ...params };
      this.$router.replace({ name: this.$route.name, query: { page: 1 } });
      this.fetchData();
    },
    onReset(params) {
      this.apiParams = { ...params };
      this.selectedPageSize = null;
      this.limit = 10;
      this.fetchData();
    },
    onPageSizeChange(size) {
      this.selectedPageSize = size;
      this.limit = size || 10;
      this.fetchData();
    },
    onPageChange(page) {
      this.$router.push({ name: this.$route.name, query: { ...this.$route.query, page } });
      this.fetchData();
    },
    viewDetail(item) {
      this.$router.push({
        name: 'warranty-outsource-info',
        query: { id: item.id },
      });
    },
    openReceiveModal(item) {
      this.selectedForReceive = item;
      this.$nextTick(() => this.$refs.receiveModalRef?.show());
    },
    onReceiveDone() {
      this.selectedForReceive = null;
      this.fetchData();
    },
    getParamFilters() {
      return {
        page: this.currentPage,
        limit: this.limit,
        startDate: this.apiParams.startDate && timeUtils.formatDBDate(this.apiParams.startDate),
        endDate: this.apiParams.endDate && timeUtils.formatDBDate(this.apiParams.endDate),
        status: this.apiParams.status,
        providerId: this.apiParams.providerId,
        storeId: this.apiParams.storeId,
        code: this.apiParams.code?.trim(),
        billId: this.apiParams.billId ? Number(this.apiParams.billId) : undefined,
        companyId: this.apiParams.companyId || undefined,
      };
    },
    async fetchData() {
      if (this.isLoading) return;
      this.isLoading = true;
      try {
        const params = this.getParamFilters();
        const data = await getOutsourceList(params);
        this.totalItems = data.totalRow || 0;
        this.numberOfPage = data.totalPage || 1;
        const dataset = data.dataset || [];
        this.listItem = dataset.map((row) => {
          const w = row.warranty || {};
          return {
            ...row,
            warrantyCode: row.warrantyCode || w.code,
            productName: row.productName || w.productName,
            imeiCode: row.imeiCode || w.imeiCode,
            customerName: row.customerName || w.customerName,
            customerPhone: row.customerPhone || w.customerPhone,
          };
        });
      } catch (e) {
        console.error(e);
        this.listItem = [];
        this.totalItems = 0;
        this.numberOfPage = 1;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.outsource-list .table th,
.outsource-list .table td {
  padding: 0.75rem;
  vertical-align: middle;
}

.outsource-list .bootstrap-datetimepicker-widget.dropdown-menu {
  width: 21em;
}
</style>

